import React, { useMemo } from 'react'
import useGetData from 'hooks/useGetData'
import { FormattedMessage } from 'react-intl'
import {
  ControlLabel
} from 'react-bootstrap'
import {
  ListItem
} from 'components/List'
import KanBoIcon from 'components/KanBoIcon'
import Button from 'components/Button'
import Loader from 'components/Loader'
import Scrollbars from 'components/Scrollbars'
import AddLayoutModal from '../AddLayoutModal'
import classes from './AddExistingLayout.module.scss'

const ARGS = { skipMyHomeLayouts: true, limit: 10000, isTemplate: false } // TODO: Convert to infinite loader

export default function AddExistingLayout ({
  layoutIds,
  requestAddMyLayout
}) {
  const {
    data,
    isLoading
  } = useGetData('HomeLayouts', ARGS)

  const notAddedLayouts = useMemo(() => {
    if (!data) return []

    return data.Layouts.filter(Layout => !Layout.IsLocked && !layoutIds.includes(Layout.Id))
  }, [data, layoutIds])

  return (
    <AddLayoutModal>
      <Scrollbars>
        <div className={classes.header}>
          <ControlLabel>
            <FormattedMessage id='DESK_ADD_EXISTING' />
          </ControlLabel>
        </div>
        {data && (
          notAddedLayouts.length
            ? (
              notAddedLayouts.map(Layout =>
                layoutIds.includes(Layout.Id)
                  ? null
                  : (
                    <ListItem
                      key={Layout.Id}
                      icon={
                        <KanBoIcon
                          name={
                            Layout.IsPublic
                              ? 'kanbo-24-desk-public-2'
                              : Layout.IsShared
                                ? 'kanbo-24-desk-shared'
                                : 'kanbo-24-desk'
                          }
                          style={{ fontSize: 24 }}
                        />
                      }
                      subtitle={Layout.Description}
                    >
                      <span className={classes.layoutTitleWrapper}>
                        <span className={classes.layoutTitle}>
                          {Layout.Name}
                        </span>
                        <Button
                          bsSize='xsmall'
                          bsStyle='primary'
                          onClick={() => requestAddMyLayout({ id: Layout.Id, position: 0 })}
                        >
                          <FormattedMessage id='ADD' />
                        </Button>
                      </span>
                    </ListItem>
                  )
              )
            )
            : (
              <div className={classes.noDesksToAdd}>
                <FormattedMessage id='DESK_ADD_NO_DESKS_TO_ADD' />
              </div>
            )
        )}
        {isLoading &&
          <div className={classes.loader}>
            <Loader center />
          </div>
        }
      </Scrollbars>
    </AddLayoutModal>
  )
}
